import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {CountAdapter} from '@drl/core/api/adapters/count-adapter.service';
import {ApiService} from '@drl/core/api/api.service';
import {Count} from '@drl/core/models';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';
import {switchMap} from 'rxjs/operators';

import {ChatNotificationAdapter} from './adapters';
import {
  GetChatNotificationsCommand,
  GetChatNotificationsCountCommand,
  PatchChatNotificationCommand,
} from './commands';
import {ChatNotification} from './models';

@Injectable()
export class ChatNotifFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    private readonly countAdapter: CountAdapter,
    private readonly chatNotifAdapter: ChatNotificationAdapter,
    private readonly systemStoreFacade: SystemStoreFacadeService,
  ) {}

  getCategories() {
    return this.systemStoreFacade.getChatCategories();
  }

  getNotifications(fromDate: Date) {
    const command: GetChatNotificationsCommand<ChatNotification> =
      new GetChatNotificationsCommand(this.apiService, this.chatNotifAdapter);

    const queryStr = JSON.stringify({
      where: {
        createdOn: {
          gte: fromDate,
        },
      },
      offset: 0,
      order: ['createdOn DESC'],
    });

    command.parameters = {
      query: new HttpParams().set('filter', queryStr),
    };

    return this.getCategories().pipe(
      switchMap(categories => command.execute()),
    );
  }

  getNotifsUnreadCount(fromDate: Date) {
    const command: GetChatNotificationsCountCommand<Count> =
      new GetChatNotificationsCountCommand(this.apiService, this.countAdapter);
    const queryStr = JSON.stringify({
      and: [
        {
          createdOn: {
            gte: fromDate,
          },
        },
        {
          isRead: false,
        },
      ],
    });

    command.parameters = {
      query: new HttpParams().set('where', queryStr),
    };

    return command.execute();
  }

  markNotifAsRead(notifIds: string[]) {
    const command: PatchChatNotificationCommand<ChatNotification> =
      new PatchChatNotificationCommand(this.apiService, this.anyAdapter);
    const queryStr = JSON.stringify({
      id: {
        inq: notifIds,
      },
    });
    command.parameters = {
      data: {
        isRead: true,
      },
      query: new HttpParams().set('where', queryStr),
    };
    return command.execute();
  }
}
